import React from 'react';
import { useModal, Icon, Modal, Body2 } from '@invent/wl-ui-kit';
import { Wrapper } from './styled';
import type { ThemeColor } from '@invent/shared-types';

interface IModulePlatformErrorFallbackProps {
  backgroundColor?: ThemeColor;
  maxHeight?: number | string;
}

export const ModulePlatformErrorFallback = ({
  backgroundColor = 'surface',
  maxHeight = 'auto'
}: IModulePlatformErrorFallbackProps) => {
  const { isOpen, openModal, closeModal } = useModal(false);

  return (
    <>
      <Wrapper $backgroundColor={backgroundColor} style={{ maxHeight }} onClick={openModal}>
        <Icon name="warning_amber" />
      </Wrapper>
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        onBackgroundClick={closeModal}
        title="Widget loading error"
      >
        <Body2 $shade="mediumEmphasis">Error fetching the data</Body2>
      </Modal>
    </>
  );
};
